// Função para verificar mudanças na propriedade "aria-hidden" da classe "search-bar__results"
function monitorarAriaHidden() {
  // Seleciona o elemento que estamos observando
  const targetNode = document.querySelector('.search-bar__results');

  // Cria uma nova instância do MutationObserver com uma função de callback
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Verifica se a propriedade "aria-hidden" mudou para false
      if (mutation.target.getAttribute('aria-hidden') === 'false') {
        // Seleciona a div com a classe "nav-bar"
        const navBar = document.querySelector('.nav-bar');
        // Altera o valor de z-index da div
        navBar.style.zIndex = '-1';
      } else if (mutation.target.getAttribute('aria-hidden') === 'true') {
        // Seleciona a div com a classe "nav-bar"
        const navBar = document.querySelector('.nav-bar');
        // Reverte o valor de z-index da div
        navBar.style.zIndex = '1';
      }
    });
  });

  // Configura e inicia a observação
  const config = { attributes: true, attributeFilter: ['aria-hidden'] };
  observer.observe(targetNode, config);
}

// Chama a função para iniciar a observação
monitorarAriaHidden();